import SimpleModal from './instantiation'

let instance

function getInstance (options) {
  instance = instance || SimpleModal.newInstance()
  instance.show(options)
}

SimpleModal.success = function (props = {}) {
  props.icon = 'success'
  props.showCancel = false
  return getInstance(props)
}

SimpleModal.warning = function (props = {}) {
  props.icon = 'warning'
  props.showCancel = false
  return getInstance(props)
}

SimpleModal.error = function (props = {}) {
  props.icon = 'error'
  props.showCancel = false
  return getInstance(props)
}

SimpleModal.confirm = function (props = {}) {
  props.icon = 'confirm'
  props.showCancel = true
  return getInstance(props)
}

SimpleModal.successLonger = function (props = {}) {
  props.modalClass = 'w750'
  props.icon = 'success'
  props.showCancel = true
  return getInstance(props)
}

export default SimpleModal
